import { ChangeDetectorRef, Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { finalize, takeUntil } from 'rxjs/operators';
import { DataService } from 'src/app/services/data.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { IceapiService } from '../../../../../services/index';
import { ClampMaterialModel } from '../../../models/index';
import { Router } from '@angular/router';
import { JointCalcService } from 'src/app/Modules/idms/components/plant-manager/services/joint-calc-service.service';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-clamp-material',
    templateUrl: './clamp-material.component.html',
    styleUrls: ['./clamp-material.component.scss'],
})
export class ClampMaterialComponent implements OnInit {
    @Input()
    set manufacturerId(value: string) {
        if (value) {
            this._manufacturerId = value;
            if (!this.jointCalcService.isPipeCode) this.getClampMaterials();
            // else {
            //     this.pipespecwithclampMaterial();
            // }
        }
    }
    get manufacturerId(): string {
        return this._manufacturerId;
    }
    @Input() form: UntypedFormGroup;
    @Input() enable: boolean;
    @Output() selected: EventEmitter<ClampMaterialModel> = new EventEmitter();
    destroy$ = new Subject();

    tooltip_position = 'above';
    loading: boolean = false;
    optionList: ClampMaterialModel[];
    private _manufacturerId: string;

    constructor(
        private iceapi: IceapiService,
        private dataService: DataService,
        private user_utility: UserUtilityService,
        private cd: ChangeDetectorRef,
        private jointCalcService: JointCalcService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.form.markAllAsTouched();

        if ((this.router.url == '/idms/plantmanager' || this.router.url.includes('/idms/plantmanagerView')) && this.jointCalcService.isPipeCode) {
            this.pipespecwithclampMaterial();
        }

        this.form
            .get('clampMaterial')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    if ((this.router.url == '/idms/plantmanager' || this.router.url.includes('/idms/plantmanagerView')) && this.jointCalcService.isPipeCode)
                        this.jointCalcService.selectedclampMaterial.next(value);
                }
            });
    }

    getClampMaterials(): void {
        this.form.markAllAsTouched();
        if (!this.manufacturerId) return;
        this.loading = true;

        this.iceapi
            .getClampMaterials(this.manufacturerId)
            .pipe(
                finalize(() => {
                    this.loading = false;
                })
            )
            .pipe(takeUntil(this.destroy$))
            .subscribe((clampMaterials) => {
                if (clampMaterials.success === true) {
                    this.optionList = clampMaterials.response;
                    this.cd.markForCheck();
                    if (this.form.get('clampMaterial').value) {
                        this.dataService.selectedClampMaterial = this.optionList.find((x) => x.clampMaterialId === this.form.get('clampMaterial').value).name;
                    }
                    if (this.optionList.length === 1) this.form.get('clampMaterial').setValue(this.optionList[0].clampMaterialId);
                } else {
                    this.user_utility.errorModelPopup(clampMaterials.message);
                }
            });
    }

    selectClampMaterial(selectedValue: MatSelectChange): void {
        const selection = this.optionList.find((x) => x.clampMaterialId === selectedValue.value);
        if (selection) {
            this.selected.emit(selection);
        }
        this.dataService.selectedClampMaterial = selection.name;
        this.form.markAllAsTouched();
    }

    async pipespecwithclampMaterial() {
        this.jointCalcService.selectedboltMaterial.pipe(takeUntil(this.destroy$)).subscribe(async (bm) => {
            if (bm) {
                const inputGroup = this.jointCalcService.pipeSpecpayload.lookupParams;

                inputGroup.recordId.pipeScheduleId =
                    inputGroup.recordId.hubMaterialId =
                    inputGroup.recordId.sealRingMaterialId =
                    inputGroup.recordId.sealRingId =
                    inputGroup.others.boltType =
                        null;
                inputGroup.recordId.boltMaterialId = bm;

                await this.findAndManagepipeSpecApiCall();
            }
        });
    }

    async findAndManagepipeSpecApiCall() {
        this.loading = true;
        let pipeSpecClampMaterial = await this.iceapi
            .getClampMaterials(this.jointCalcService.pipeSpecpayload.lookupParams.recordId.manufacturerId)
            .pipe(finalize(() => (this.loading = false)))
            .toPromise();

        if (pipeSpecClampMaterial.success) {
            this.optionList = pipeSpecClampMaterial.response;
            this.optionList = await this.jointCalcService.managePayloadForRecourdId('clampMaterialId', this.optionList);

            if (
                this.dataService?.calculationData?.input?.recordId?.clampMaterialId &&
                this.optionList.some((x) => x.clampMaterialId === this.dataService?.calculationData?.input?.recordId?.clampMaterialId)
            ) {
                this.form.get('clampMaterial').setValue(this.dataService?.calculationData?.input?.recordId?.clampMaterialId);
            } else if (this.optionList.length === 1) {
                this.form.get('clampMaterial').setValue(this.optionList[0].clampMaterialId);
            }
        } else if (pipeSpecClampMaterial.isCustom) {
            this.user_utility.errorModelPopup(pipeSpecClampMaterial.message);
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
